import { Component, Input } from "@angular/core";
import { AppLayoutComponent } from "../../../../shared/components/app-layout/app-layout.component";
import { MatIconModule } from "@angular/material/icon";
import { EventInfo } from "../../../services/types/events-management-request.type";
import { SkeletonModule } from "primeng/skeleton";
import { RouterModule } from "@angular/router";

@Component({
    selector: "app-collaborators-invitation-success",
    imports: [AppLayoutComponent, MatIconModule, SkeletonModule, RouterModule],
    templateUrl: "./collaborators-invitation-success.component.html",
    styleUrl: "./collaborators-invitation-success.component.scss"
})
export class CollaboratorsInvitationSuccessComponent {
  @Input() event: EventInfo | null = null;
}
